import {
    changeNotificationDescription,
    changeNotificationProceedBtnTxt,
    changeNotificationTitle,
    notificationListStage,
} from "./constants";

export function getModalConfig(stage) {
    const configs = {
        [notificationListStage.REOPEN]: {
            titleText: changeNotificationTitle.REOPEN,
            descriptionText: changeNotificationDescription.REOPEN,
            proceedText: changeNotificationProceedBtnTxt.REOPEN,
        },
        [notificationListStage.APPROVE_CONFIRMATION]: {
            titleText: changeNotificationTitle.APPROVE_CONFIRMATION,
            descriptionText: changeNotificationDescription.APPROVE_CONFIRMATION,
            proceedText: changeNotificationProceedBtnTxt.APPROVE_CONFIRMATION,
        },
    };

    return configs[stage];
}
